import { defaults } from 'lodash-es'

export const checkPoint = (point) =>
  Array.isArray(point) &&
  point.length === 2 &&
  point.every((c) => typeof c === 'number')

export const checkPath = (path) => path.every((point) => checkPoint(point))

/**
 * 获取path
 * type Path = Array<[number, number]>
 * 有些coordinates类型为Path，有些则是GeoJSON格式
 * @param {*} coordinates
 * @returns
 */
export const getDeepPath = (coordinates) => {
  let path = coordinates
  while (Array.isArray(path[0]) && Array.isArray(path[0][0])) {
    ;[path] = path
  }

  return path
}

// 多边形 type-Polygon
const polygonsDataCheck = (geo) => {
  return (
    Array.isArray(geo.coordinates) && checkPath(getDeepPath(geo.coordinates))
  )
}

// 点位 type-Point
const pointDataCheck = (geo) => {
  return checkPoint(geo.coordinates)
}

const validatorConfig = {
  Point: pointDataCheck,
  Polygon: polygonsDataCheck,
}

/**
 * 校验geoInfo的坐标信息是否正确，防止[null, null]导致的渲染失败
 * @param {*} data
 * @returns 过滤后的列表
 */
export const avaliableGeoInfoFilter = (data) => {
  if (!Array.isArray(data)) return []

  return data.filter((geo) => {
    if (!geo) return false
    const validator = validatorConfig[geo.type]
    if (validator) {
      return validator(geo)
    }
    return true
  })
}

/**
 * 合并默认配置
 * @param {*} defaultConfig
 * @param {*} customConfig
 * @returns
 */
export const getConfigWithDefaults = (defaultConfig, customConfig) => {
  if (!customConfig) return defaultConfig

  return defaults({ ...customConfig }, defaultConfig)
}
